import {

  useState

} from "react";

import {

  Outlet,
  NavLink,
  useLocation,
  useNavigate

} from "react-router-dom";

import {

  LayoutDashboard,
  FileText,
  Wallet,
  QrCode,
  Users,
  BarChart3,
  Menu,
  X,
  ChevronLeft,
  ChevronRight,
  LogOut

} from "lucide-react";

import {

  motion,
  AnimatePresence

} from "framer-motion";

// =====================================
// COMPONENT
// =====================================

export default function AppShell() {

  // =====================================
  // NAVIGATION
  // =====================================

  const navigate =
    useNavigate();

  const location =
    useLocation();

  // =====================================
  // STATES
  // =====================================

  const [collapsed,
    setCollapsed] =
    useState(false);

  const [mobileOpen,
    setMobileOpen] =
    useState(false);

  // =====================================
  // SAFE USER PARSE
  // =====================================

  let user = {};

  try {

    user = JSON.parse(

      localStorage.getItem(
        "user"
      )
      

    ) || {};

  } catch {

    user = {};
  }

  // =====================================
  // ROLE
  // =====================================

  const role =

    String(
      user?.role || ""
    ).toLowerCase();

  // =====================================
  // MENU ITEMS
  // =====================================

 let menu = [];

// =====================================
// MANAGER
// =====================================

if (role === "manager") {

  menu = [

    {
      name: "Dashboard",
      path: "/",
      icon: LayoutDashboard
    },

    {
      name: "Manager Approvals",
      path: "/manager-approvals",
      icon: FileText
    },

    {
      name: "Reports",
      path: "/manager-reports",
      icon: BarChart3
    },

    {
      name: "Incentive List",
      path: "/incentive-matrix",
      icon: Wallet
    }

  ];

}

// =====================================
// CEO
// =====================================

else if (role === "ceo") {

  menu = [

    {
      name: "Dashboard",
      path: "/",
      icon: LayoutDashboard
    },

    {
      name: "CEO Approvals",
      path: "/final-approval",
      icon: FileText
    },

    {
      name: "Reports",
      path: "/ceo-reports",
      icon: BarChart3
    },

    {
      name: "Incentive List",
      path: "/incentive-matrix",
      icon: Wallet
    }

  ];

}

// =====================================
// FINANCE
// =====================================

else if (role === "finance") {

  menu = [

    {
      name: "Dashboard",
      path: "/",
      icon: LayoutDashboard
    },

    {
      name: "Payouts",
      path: "/payouts",
      icon: Wallet
    },

    {
      name: "Reports",
      path: "/finance-reports",
      icon: BarChart3
    },

    {
      name: "Incentive List",
      path: "/incentive-matrix",
      icon: Wallet
    }

  ];

}

// =====================================
// ADMIN
// =====================================

else if (role === "admin") {

  menu = [

    {
      name: "Dashboard",
      path: "/",
      icon: LayoutDashboard
    },

    {
      name: "QR Generator",
      path: "/qr",
      icon: QrCode
    },

    {
      name: "Assign Salesman",
      path: "/assign-salesman",
      icon: Users
    },

    {
      name: "Assign Manager",
      path: "/assign-manager",
      icon: Users
    },

    {
      name: "Incentive List",
      path: "/incentive-matrix",
      icon: Wallet
    }

  ];

}

// =====================================
// SALESMAN
// =====================================

else if (role === "salesman") {

  menu = [

    {
      name: "Dashboard",
      path: "/",
      icon: LayoutDashboard
    },

    {
      name: "New Claim",
      path: "/sales",
      icon: FileText
    },

    {
      name: "My Claims",
      path: "/my-claims",
      icon: FileText
    }

  ];

}

// =====================================
// DEFAULT
// =====================================

else {

  menu = [

    {
      name: "Dashboard",
      path: "/",
      icon: LayoutDashboard
    }

  ];

}
  // =====================================
  // LOGOUT
  // =====================================

  const logout = () => {

    localStorage.removeItem(
      "token"
    );

    localStorage.removeItem(
      "user"
    );

    navigate("/login");
  };

  // =====================================
  // SIDEBAR CONTENT
  // =====================================

  const SidebarContent = () => (

    <>

      {/* =====================================
          LOGO
      ===================================== */}

      <div
        className="
        h-20
        flex
        items-center
        justify-between
        px-5
        border-b
        border-gray-800
      "
      >

        {/* BRAND */}

        <div
          className="
          flex
          items-center
          gap-3
        "
        >

          <div
            className="
            w-12
            h-12
            rounded-2xl
            bg-primary
            flex
            items-center
            justify-center
            text-white
            font-bold
            text-xl
            shadow-lg
          "
          >
            C
          </div>

          {
            !collapsed && (

              <div>

                <h1
                  className="
                  text-xl
                  font-bold
                  text-white
                "
                >
                  Canon ERP
                </h1>

                <p
                  className="
                  text-xs
                  text-gray-400
                "
                >
                  Sales Incentive System
                </p>

              </div>
            )
          }

        </div>

        {/* COLLAPSE */}

        <button
          onClick={() =>
            setCollapsed(
              !collapsed
            )
          }
          className="
          hidden
          lg:flex
          w-9
          h-9
          rounded-xl
          bg-gray-800
          items-center
          justify-center
          hover:bg-gray-700
          transition
        "
        >

          {
            collapsed

            ? <ChevronRight size={18} />

            : <ChevronLeft size={18} />
          }

        </button>

      </div>

      {/* =====================================
          MENU
      ===================================== */}

      <nav
        className="
        flex-1
        p-4
        space-y-2
        overflow-y-auto
      "
      >

        {
          menu.map((item) => {

            const Icon =
              item.icon;

            const active =

              location.pathname ===
              item.path;

            return (

              <NavLink
                key={item.path}
                to={item.path}
                onClick={() =>
                  setMobileOpen(
                    false
                  )
                }
                className={`

                  relative
                  flex
                  items-center
                  gap-4
                  px-4
                  py-4
                  rounded-2xl
                  transition-all
                  duration-200
                  overflow-hidden

                  ${
                    active

                    ? `
                      bg-primary
                      text-white
                      shadow-xl
                    `

                    : `
                      text-gray-300
                      hover:bg-gray-800
                      hover:text-white
                    `
                  }
                `}
              >

                {/* ACTIVE BACKGROUND */}

                {
                  active && (

                    <motion.div
                      layoutId="active-pill"
                      className="
                      absolute
                      inset-0
                      bg-primary
                      rounded-2xl
                    "
                    />
                  )
                }

                {/* ICON */}

                <div
                  className="
                  relative
                  z-10
                "
                >

                  <Icon size={22} />

                </div>

                {/* LABEL */}

                {
                  !collapsed && (

                    <span
                      className="
                      relative
                      z-10
                      font-medium
                    "
                    >
                      {item.name}
                    </span>
                  )
                }

              </NavLink>
            );
          })
        }

      </nav>

      {/* =====================================
          USER SECTION
      ===================================== */}

      <div
        className="
        p-4
        border-t
        border-gray-800
      "
      >

        {/* PROFILE */}

        <div
          className="
          flex
          items-center
          gap-3
          mb-4
        "
        >

          <div
            className="
            w-12
            h-12
            rounded-2xl
            bg-primary
            flex
            items-center
            justify-center
            text-white
            font-bold
            shadow-lg
          "
          >
            {
              user?.name?.[0]
              || "U"
            }
          </div>

          {
            !collapsed && (

              <div>

                <p
                  className="
                  font-semibold
                  text-white
                "
                >
                  {
                    user?.name
                    || "User"
                  }
                </p>

                <p
                  className="
                  text-xs
                  text-gray-400
                  capitalize
                "
                >
                  {
                    user?.role
                    || "Role"
                  }
                </p>

              </div>
            )
          }

        </div>

        {/* LOGOUT */}

        <button
          onClick={logout}
          className="
          w-full
          flex
          items-center
          justify-center
          gap-3
          bg-red-600
          hover:bg-red-700
          transition
          py-3
          rounded-2xl
          font-semibold
          text-white
        "
        >

          <LogOut size={18} />

          {
            !collapsed &&
            "Logout"
          }

        </button>

      </div>

    </>
  );

  // =====================================
  // UI
  // =====================================

  return (

    <div
      className="
      flex
      h-screen
      bg-gray-100
      overflow-hidden
    "
    >

      {/* =====================================
          MOBILE OVERLAY
      ===================================== */}

      <AnimatePresence>

        {
          mobileOpen && (

            <motion.div

              initial={{
                opacity: 0
              }}

              animate={{
                opacity: 1
              }}

              exit={{
                opacity: 0
              }}

              onClick={() =>
                setMobileOpen(
                  false
                )
              }

              className="
              fixed
              inset-0
              bg-black/50
              z-40
              lg:hidden
            "
            />
          )
        }

      </AnimatePresence>

      {/* =====================================
          DESKTOP SIDEBAR
      ===================================== */}

      <motion.aside

        animate={{
          width:
            collapsed

            ? 100

            : 280
        }}

        className="
        hidden
        lg:flex
        flex-col
        bg-dark
        text-white
        shadow-2xl
        z-30
      "
      >

        <SidebarContent />

      </motion.aside>

      {/* =====================================
          MOBILE SIDEBAR
      ===================================== */}

      <AnimatePresence>

        {
          mobileOpen && (

            <motion.aside

              initial={{
                x: -300
              }}

              animate={{
                x: 0
              }}

              exit={{
                x: -300
              }}

              transition={{
                type: "spring",
                stiffness: 260,
                damping: 25
              }}

              className="
              fixed
              top-0
              left-0
              h-full
              w-72
              bg-dark
              text-white
              z-50
              flex
              flex-col
              shadow-2xl
              lg:hidden
            "
            >

              {/* CLOSE */}

              <div
                className="
                absolute
                top-5
                right-5
              "
              >

                <button
                  onClick={() =>
                    setMobileOpen(
                      false
                    )
                  }
                  className="
                  w-10
                  h-10
                  rounded-xl
                  bg-gray-800
                  flex
                  items-center
                  justify-center
                "
                >

                  <X size={20} />

                </button>

              </div>

              <SidebarContent />

            </motion.aside>
          )
        }

      </AnimatePresence>

      {/* =====================================
          MAIN AREA
      ===================================== */}

      <div
        className="
        flex-1
        flex
        flex-col
        overflow-hidden
      "
      >

        {/* =====================================
            TOPBAR
        ===================================== */}

        <header
          className="
          h-20
          bg-white
          border-b
          border-gray-200
          px-6
          flex
          items-center
          justify-between
          shadow-sm
        "
        >

          {/* LEFT */}

          <div
            className="
            flex
            items-center
            gap-4
          "
          >

            <button
              onClick={() =>
                setMobileOpen(
                  true
                )
              }
              className="
              lg:hidden
              w-11
              h-11
              rounded-2xl
              bg-gray-100
              flex
              items-center
              justify-center
            "
            >

              <Menu size={22} />

            </button>

            <div>

              <h2
                className="
                text-2xl
                font-bold
                text-gray-800
              "
              >
                Welcome Back 👋
              </h2>

              <p
                className="
                text-sm
                text-gray-500
              "
              >
                Canon ERP Dashboard
              </p>

            </div>

          </div>

          {/* RIGHT */}

          <div
            className="
            flex
            items-center
            gap-4
          "
          >

            <div
              className="
              hidden
              md:flex
              items-center
              gap-3
            "
            >

              <div
                className="
                text-right
              "
              >

                <p
                  className="
                  font-semibold
                  text-gray-800
                "
                >
                  {
                    user?.name
                    || "User"
                  }
                </p>

                <p
                  className="
                  text-xs
                  text-gray-500
                  capitalize
                "
                >
                  {
                    user?.role
                    || "Role"
                  }
                </p>

              </div>

              <div
                className="
                w-12
                h-12
                rounded-2xl
                bg-primary
                text-white
                flex
                items-center
                justify-center
                font-bold
                shadow-lg
              "
              >
                {
                  user?.name?.[0]
                  || "U"
                }
              </div>

            </div>

          </div>

        </header>

        {/* =====================================
            PAGE CONTENT
        ===================================== */}

        <main
          className="
          flex-1
          overflow-y-auto
          p-6
        "
        >

          <Outlet />

        </main>

      </div>

    </div>
  );
}